/* src/app/shared/reclaim/recl-xml-mcs-bitacora-rev032025/recl-xml-mcs-bitacora-rev032025.component.css */
input {
  cursor: pointer;
  border: 1px solid orange;
}
.currcy {
  text-align: right;
}
.font10 {
  font-size: 10px;
}
.txtMCSprovNm {
  position: absolute;
  top: 157px;
  left: 250px;
}
.txtMCSprovNPI {
  position: absolute;
  top: 157px;
  left: 888px;
}
.txtMCSprovAddPO1 {
  position: absolute;
  top: 205px;
  left: 290px;
}
.txtMCSprovAddPO2 {
  position: absolute;
  top: 235px;
  left: 290px;
}
.txtMCSprovAddPOzip {
  position: absolute;
  top: 205px;
  left: 733px;
}
.txtMCSprovAddTel {
  position: absolute;
  top: 205px;
  left: 910px;
}
.txtMCSprovEmail {
  position: absolute;
  top: 235px;
  left: 910px;
}
.optMCScomercial {
  position: absolute;
  top: 260px;
  left: 388px;
}
.optMCSadvantage {
  position: absolute;
  top: 260px;
  left: 588px;
}
.optMCSpending {
  position: absolute;
  top: 362px;
  left: 230px;
}
.optMCSadjust {
  position: absolute;
  top: 362px;
  left: 818px;
}
.txtMCSpatNm1 {
  position: absolute;
  top: 483px;
  left: 45px;
}
.txtMCScontrNo1 {
  position: absolute;
  top: 483px;
  left: 230px;
}
.txtMCSfrmDt1 {
  position: absolute;
  top: 483px;
  left: 356px;
}
.txtMCStoDt1 {
  position: absolute;
  top: 483px;
  left: 455px;
}
.txtMCScpt1 {
  position: absolute;
  top: 483px;
  left: 555px;
}
.txtMCSbal1 {
  position: absolute;
  top: 483px;
  left: 663px;
}
.txtMCScoment1 {
  position: absolute;
  top: 483px;
  left: 770px;
}
.txtMCSpatNm2 {
  position: absolute;
  top: 512px;
  left: 45px;
}
.txtMCScontrNo2 {
  position: absolute;
  top: 512px;
  left: 230px;
}
.txtMCSfrmDt2 {
  position: absolute;
  top: 512px;
  left: 356px;
}
.txtMCStoDt2 {
  position: absolute;
  top: 512px;
  left: 455px;
}
.txtMCScpt2 {
  position: absolute;
  top: 513px;
  left: 555px;
}
.txtMCSbal2 {
  position: absolute;
  top: 514px;
  left: 663px;
}
.txtMCScoment2 {
  position: absolute;
  top: 515px;
  left: 770px;
}
.txtMCSpatNm3 {
  position: absolute;
  top: 537px;
  left: 45px;
}
.txtMCScontrNo3 {
  position: absolute;
  top: 537px;
  left: 230px;
}
.txtMCSfrmDt3 {
  position: absolute;
  top: 537px;
  left: 356px;
}
.txtMCStoDt3 {
  position: absolute;
  top: 538px;
  left: 455px;
}
.txtMCScpt3 {
  position: absolute;
  top: 539px;
  left: 555px;
}
.txtMCSbal3 {
  position: absolute;
  top: 540px;
  left: 663px;
}
.txtMCScoment3 {
  position: absolute;
  top: 541px;
  left: 770px;
}
.txtMCSpatNm4 {
  position: absolute;
  top: 566px;
  left: 45px;
}
.txtMCScontrNo4 {
  position: absolute;
  top: 566px;
  left: 230px;
}
.txtMCSfrmDt4 {
  position: absolute;
  top: 566px;
  left: 356px;
}
.txtMCStoDt4 {
  position: absolute;
  top: 566px;
  left: 455px;
}
.txtMCScpt4 {
  position: absolute;
  top: 566px;
  left: 555px;
}
.txtMCSbal4 {
  position: absolute;
  top: 567px;
  left: 663px;
}
.txtMCScoment4 {
  position: absolute;
  top: 568px;
  left: 770px;
}
.txtMCSpatNm5 {
  position: absolute;
  top: 594px;
  left: 45px;
}
.txtMCScontrNo5 {
  position: absolute;
  top: 594px;
  left: 230px;
}
.txtMCSfrmDt5 {
  position: absolute;
  top: 594px;
  left: 356px;
}
.txtMCStoDt5 {
  position: absolute;
  top: 594px;
  left: 455px;
}
.txtMCScpt5 {
  position: absolute;
  top: 594px;
  left: 555px;
}
.txtMCSbal5 {
  position: absolute;
  top: 595px;
  left: 663px;
}
.txtMCScoment5 {
  position: absolute;
  top: 596px;
  left: 770px;
}
.txtMCSpatNm6 {
  position: absolute;
  top: 623px;
  left: 45px;
}
.txtMCScontrNo6 {
  position: absolute;
  top: 623px;
  left: 230px;
}
.txtMCSfrmDt6 {
  position: absolute;
  top: 623px;
  left: 356px;
}
.txtMCStoDt6 {
  position: absolute;
  top: 623px;
  left: 455px;
}
.txtMCScpt6 {
  position: absolute;
  top: 623px;
  left: 555px;
}
.txtMCSbal6 {
  position: absolute;
  top: 624px;
  left: 663px;
}
.txtMCScoment6 {
  position: absolute;
  top: 625px;
  left: 770px;
}
.txtMCSpatNm7 {
  position: absolute;
  top: 649px;
  left: 45px;
}
.txtMCScontrNo7 {
  position: absolute;
  top: 649px;
  left: 230px;
}
.txtMCSfrmDt7 {
  position: absolute;
  top: 649px;
  left: 356px;
}
.txtMCStoDt7 {
  position: absolute;
  top: 650px;
  left: 455px;
}
.txtMCScpt7 {
  position: absolute;
  top: 651px;
  left: 555px;
}
.txtMCSbal7 {
  position: absolute;
  top: 652px;
  left: 663px;
}
.txtMCScoment7 {
  position: absolute;
  top: 653px;
  left: 770px;
}
.footer {
  position: absolute;
  top: 840px;
  left: 0px;
  width: 100%;
  height: 0;
  background-color: #f1f1f1;
  text-align: center;
}
/*# sourceMappingURL=recl-xml-mcs-bitacora-rev032025.component.css.map */
